/**
 * Execute provided promises
 * @param {Array} funcs - array of functions
 * @param {Function} cb - function to call when all functions done
 */
export default function (funcs, cb, debug) {
  const queue = []
  const queueExec = {}

  for (let func of funcs) {
    if (!func.name) throw new Error('[Loading Queue] function name required for debug puroposes.')
    if (queueExec[func.name]) throw new Error('[Loading Queue] function name duplicated.')
    if (typeof func.promise !== 'object') new Error(`[Loading Queue] ${func.name}.promise must contain Promise.`)
    if (!(func.promise instanceof Promise)) new Error(`[Loading Queue] ${func.name}.promise must contain Promise.`)

    queue.push(new Promise((resolve, reject) => {
      queueExec[func.name] = 'started'

      func.promise.then(() => {
        queueExec[func.name] = 'finished'
        resolve()
      }).catch((err) => {
        queueExec[func.name] = 'failed'
        reject(err)
      })
    }))
  }

  Promise
    .all(queue)
    .then(() => {
      if (cb) cb()
    })

  if (debug) console.log(queueExec)
}
